import React from 'react'

const Features = () => {
    return (
        <div id='features' className="features-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2 className='text-center top-reveal'>Revolutionary Features</h2>
                    </div>
                </div>
                <div className="row row-gap-4 justify-content-center">
                    <div className="col-lg-3 col-md-6 top-reveal">
                        <div className="features-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="30" viewBox="0 0 38 30" fill="none">
                                <g clip-path="url(#clip0_1_252)">
                                    <path d="M23.3438 0.0703101C22.3477 -0.216799 21.3105 0.363279 21.0234 1.35937L13.5234 27.6094C13.2363 28.6055 13.8164 29.6426 14.8125 29.9297C15.8086 30.2168 16.8457 29.6367 17.1328 28.6406L24.6328 2.39062C24.9199 1.39453 24.3398 0.357419 23.3438 0.0703101ZM28.0664 7.10742C27.334 7.83984 27.334 9.02929 28.0664 9.76172L33.2988 15L28.0605 20.2383C27.3281 20.9707 27.3281 22.1602 28.0605 22.8926C28.793 23.625 29.9824 23.625 30.7148 22.8926L37.2773 16.3301C38.0098 15.5977 38.0098 14.4082 37.2773 13.6758L30.7148 7.11328C29.9824 6.38086 28.793 6.38086 28.0605 7.11328L28.0664 7.10742ZM10.0957 7.10742C9.36328 6.375 8.17383 6.375 7.44141 7.10742L0.878906 13.6699C0.146484 14.4023 0.146484 15.5918 0.878906 16.3242L7.44141 22.8867C8.17383 23.6191 9.36328 23.6191 10.0957 22.8867C10.8281 22.1543 10.8281 20.9648 10.0957 20.2324L4.85742 15L10.0957 9.76172C10.8281 9.02929 10.8281 7.83984 10.0957 7.10742Z" fill="#3B82F6" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1_252">
                                        <path d="M0.328125 0H37.8281V30H0.328125V0Z" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 style={{ marginTop: "10px" }}>Secure Fund Management</h3>
                            <p>
                                Decentralized fund management through blockchain technology guarantees transparency
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 top-reveal">
                        <div className="features-item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                <g clip-path="url(#clip0_1_242)">
                                    <path d="M15 0C15.2695 0 15.5391 0.0585938 15.7852 0.169922L26.8184 4.85156C28.1074 5.39648 29.0684 6.66797 29.0625 8.20312C29.0332 14.0156 26.6426 24.6504 16.5469 29.4844C15.5684 29.9531 14.4316 29.9531 13.4531 29.4844C3.35742 24.6504 0.966793 14.0156 0.937496 8.20312C0.931637 6.66797 1.89257 5.39648 3.18164 4.85156L14.2207 0.169922C14.4609 0.0585938 14.7305 0 15 0ZM15 3.91406V26.0625C23.0859 22.1484 25.2598 13.4824 25.3125 8.28516L15 3.91406Z" fill="#3B82F6" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1_242">
                                        <path d="M0 0H30V30H0V0Z" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 style={{ marginTop: "10px" }}>Secure Card Dealing</h3>
                            <p>
                                Advanced P2P encryption and decryption ensure your gameplay is completely secure and private
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 top-reveal">
                        <div className="features-item">
                            <svg
                                viewBox="0 0 1024 1024"
                                width={44}
                                height={44}
                                style={{ marginTop: '-4px' }}
                            >
                                <defs id="defs4" />
                                {/* Main group */}
                                <g id="dice-container" transform="rotate(45, 512, 512)">
                                    <g transform="matrix(1.5,0,0,1.5,109.02942,-468.01519)" id="g3674">
                                        <path
                                            id="path3586"
                                            d="M 245,341.5 C 252.5,329 270,314 282.5,314 L 557.5,469 C 562.5,474 575,506.5 565,519 L 292.5,679 C 285,681.5 252.5,679 242.5,654 L 245,341.5 z"
                                            fill="#404040"
                                            fillOpacity={1}
                                            fillRule="evenodd"
                                            stroke="#404040"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeMiterlimit={4}
                                            strokeDasharray="none"
                                            strokeOpacity={1}
                                        />
                                        <g
                                            transform="matrix(0.1910977,-0.3317217,0.1910977,0.3317217,152.64427,500.07482)"
                                            id="g3515"
                                            style={{ overflow: 'visible' }}
                                        >
                                            <path
                                                id="path3491"
                                                d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                fill="#3B82F6"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={7}
                                            />
                                            <circle
                                                id="circle3493"
                                                cx="278.5"
                                                cy="278.5"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                        </g>
                                        <g
                                            transform="matrix(-0.3828283,3.653872e-4,0.1917306,-0.3313563,472.998,680.25529)"
                                            id="g3558"
                                            style={{ overflow: 'visible' }}
                                        >
                                            <path
                                                id="path3566"
                                                d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                fill="#3B82F6"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={7}
                                            />
                                            <circle
                                                id="circle3560"
                                                cx="117.02637"
                                                cy="439.97461"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3562"
                                                cx="439.97461"
                                                cy="439.97461"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3564"
                                                cx="439.97314"
                                                cy="117.02588"
                                                r="57.114746"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3568"
                                                cx="278.5"
                                                cy="278.5"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3570"
                                                cx="117.02588"
                                                cy="117.02563"
                                                r="57.115479"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                        </g>
                                        <g
                                            transform="matrix(0.1917306,0.3313563,-0.3828283,-3.653872e-4,468.80258,313.31549)"
                                            id="g3572"
                                            style={{ overflow: 'visible' }}
                                        >
                                            <path
                                                id="path3580"
                                                d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                fill="#3B82F6"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={7}
                                            />
                                            <circle
                                                id="circle3574"
                                                cx="117.02637"
                                                cy="439.97461"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3576"
                                                cx="439.97461"
                                                cy="439.97461"
                                                r="57.115234"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3578"
                                                cx="439.97314"
                                                cy="117.02588"
                                                r="57.114746"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                            <circle
                                                id="circle3584"
                                                cx="117.02588"
                                                cy="117.02563"
                                                r="57.115479"
                                                fill="#404040"
                                                fillOpacity={1}
                                                stroke="#000000"
                                                strokeWidth={5}
                                                strokeOpacity={1}
                                            />
                                        </g>
                                    </g>
                                    {/* Second big group */}
                                    <g transform="matrix(1.5,0,0,1.5,-774.05268,372.6114)" id="g3658">
                                        <g transform="matrix(0,1,-1,0,1481.1182,-519.93236)" id="g3634">
                                            <path
                                                id="path3590"
                                                d="M 628.93236,528.61822 C 636.43236,516.11822 653.93236,501.11822 666.43236,501.11822 L 945.11486,661.94515 C 949.23133,668.60311 957.52152,683.02388 950.41128,703.51533 L 676.43236,866.11822 C 668.93236,868.61822 636.43236,866.11822 626.43236,841.11822 L 628.93236,528.61822 z"
                                                fill="#404040"
                                                fillOpacity={1}
                                                fillRule="evenodd"
                                                stroke="#404040"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeMiterlimit={4}
                                                strokeDasharray="none"
                                                strokeOpacity={1}
                                            />
                                            <g
                                                transform="matrix(0.1910977,-0.3317217,0.1910977,0.3317217,536.57663,687.19304)"
                                                id="g3592"
                                                style={{ overflow: 'visible' }}
                                            >
                                                <path
                                                    id="path3594"
                                                    d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                    fill="#3B82F6"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={7}
                                                />
                                                <circle
                                                    id="circle3602"
                                                    cx="278.5"
                                                    cy="278.5"
                                                    r="57.115234"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                            </g>
                                            <g
                                                transform="matrix(-0.3828283,3.653872e-4,0.1917306,-0.3313563,856.93036,867.37351)"
                                                id="g3606"
                                                style={{ overflow: 'visible' }}
                                            >
                                                <path
                                                    id="path3608"
                                                    d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                    fill="#3B82F6"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={7}
                                                />
                                                <circle
                                                    id="circle3610"
                                                    cx="117.02637"
                                                    cy="439.97461"
                                                    r="57.115234"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                                <circle
                                                    id="circle3614"
                                                    cx="439.97314"
                                                    cy="117.02588"
                                                    r="57.114746"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                            </g>
                                            <g
                                                transform="matrix(0.1917306,0.3313563,-0.3828283,-3.653872e-4,852.73494,500.43371)"
                                                id="g3620"
                                                style={{ overflow: 'visible' }}
                                            >
                                                <path
                                                    id="path3622"
                                                    d="M 71.459473,553.5 C 34.080566,553.5 3.5,522.91895 3.5,485.54004 L 3.5,71.459473 C 3.5,34.082031 34.080566,3.5 71.459473,3.5 L 485.54004,3.5 C 522.91797,3.5 553.5,34.082031 553.5,71.459473 L 553.5,485.54004 C 553.5,522.91895 522.91797,553.5 485.54004,553.5 L 71.459473,553.5 z"
                                                    fill="#3B82F6"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={7}
                                                />
                                                <circle
                                                    id="circle3624"
                                                    cx="117.02637"
                                                    cy="439.97461"
                                                    r="57.115234"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                                <circle
                                                    id="circle3628"
                                                    cx="439.97314"
                                                    cy="117.02588"
                                                    r="57.114746"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                                <circle
                                                    id="circle3630"
                                                    cx="278.5"
                                                    cy="278.5"
                                                    r="57.115234"
                                                    fill="#404040"
                                                    fillOpacity={1}
                                                    stroke="#000000"
                                                    strokeWidth={5}
                                                    strokeOpacity={1}
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <h3>Unique RNG</h3>
                            <p>
                                Fair shuffling powered by both server and players for true RNG
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 top-reveal">
                        <div className="features-item">
                            <svg
                                width="42"
                                height="42"
                                viewBox="0 0 68 68"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                {/* Pump body */}
                                <rect x="10" y="15" width="25" height="35" rx="2" strokeWidth="3" stroke="#3B82F6" />
                                {/* Display area */}
                                <rect x="15" y="20" width="16" height="9" strokeWidth="3" stroke="#3B82F6" />
                                {/* Nozzle / hose */}
                                <path d="M35 20 L45 10 L50 15 L50 25" strokeWidth="3" stroke="#3B82F6" />
                                {/* “No Gas” cross */}
                                <line x1="2" y1="5" x2="53" y2="53" strokeWidth="3" stroke="#3B82F6" />
                                {/* <line x1="59" y1="5" x2="5" y2="59" /> */}
                            </svg>
                            <h3>Gasless Gameplay</h3>
                            <p>
                                Our Gasless Gameplay eliminates transaction costs so you can concentrate on winning not on gas fees
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features